/**
 * syncStructureRenderState — Living vs destroyed structure visuals (no HP when dead).
 */
export function syncStructureRenderState(tr) {
  if (!tr || !tr.entity || !tr.group) return 'missing';
  if (tr.entity.isDead) {
    applyDestroyedLook(tr);
    return 'destroyed';
  }
  applyLivingLook(tr);
  return 'living';
}

function applyDestroyedLook(tr) {
  tr.group.visible = true;
  if (tr.plateDiv) tr.plateDiv.style.display = 'none';
  if (tr.group.userData.destroyedApplied) return;
  tr.group.userData.destroyedApplied = true;
  tr.group.traverse((child) => {
    if (!child.isMesh) return;
    const part = child.userData?.structurePart;
    if (part === 'core' || part === 'gem' || part === 'range' || part === 'crystal') {
      child.visible = false;
      return;
    }
    tintRubbleMaterial(child.material);
  });
}

function applyLivingLook(tr) {
  tr.group.visible = true;
  if (tr.plateDiv) tr.plateDiv.style.display = 'flex';
  if (!tr.group.userData.destroyedApplied) return;
  tr.group.userData.destroyedApplied = false;
  tr.group.traverse((child) => {
    if (!child.isMesh) return;
    child.visible = true;
    restoreMaterial(child.material, child.userData?.baseColor);
  });
}

function tintRubbleMaterial(material) {
  const mats = Array.isArray(material) ? material : [material];
  for (const m of mats) {
    if (!m) continue;
    if (m.color) m.color.setHex(0x334155);
    if (m.emissive) m.emissive.setHex(0x000000);
    m.transparent = true;
    m.opacity = 0.75;
  }
}

function restoreMaterial(material, baseColor) {
  const mats = Array.isArray(material) ? material : [material];
  for (const m of mats) {
    if (!m) continue;
    if (m.color && typeof baseColor === 'number') m.color.setHex(baseColor);
    m.transparent = false;
    m.opacity = 1;
  }
}
